import { Component, EventEmitter, OnChanges, OnInit, Output, input, model, output } from '@angular/core';
import { FormBuilder } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog'
import { Router } from '@angular/router';
import { faTrash, faUsers, faWarning } from '@fortawesome/free-solid-svg-icons';
import { faCircleXmark } from '@fortawesome/free-regular-svg-icons';
import { IconProp } from '@fortawesome/fontawesome-svg-core';
import { Editor, Toolbar } from 'ngx-editor';
import { ReportService } from 'src/app/services/report.service';
import { MatTableDataSource } from '@angular/material/table';
import { UserService } from 'src/app/services/user.service';
import { DialogService } from 'src/app/services/dialog.service';
import { ReportForest } from 'src/app/models/reportForest.model';
import { ConfirmationToastComponent } from 'src/app/components/confirmation-toast/confirmation-toast.component';
import { APP_CONSTANTS } from 'src/app/shared/app.constants';

@Component({
    selector: 'app-select-line-officer',
    templateUrl: './select-line-officer.component.html',
    styleUrls: ['./select-line-officer.component.scss'],
    standalone: false
})


export class SelectLineOfficerComponent implements OnChanges, OnInit {

  faUsers = faUsers;
  faTrash = faTrash;
  faWarning = faWarning;
  faCircleXmark = faCircleXmark as IconProp;
  filtered_roles: any[] = [];

  toolbar: Toolbar = APP_CONSTANTS.EDITOR_TOOLBAR;

  editors: Editor[] = [];

  report = input.required<any>();
  nav = model.required<string>();
  status = output<number | undefined>();
  @Output() loaded = new EventEmitter();
  errorList: string[] = [];
  is_co = input.required<boolean>();
  forests: any[] = []
  lastCheckedEmail: any = "";
  roles: any;
  page = input("8");


  displayedColumns: string[] = ["name", "position", "forest"];
  users = new MatTableDataSource<any>();
  selectUserId: number | null = null;

  fireForm = this.formBuilder.group({
    radio: [""],
  });

  doesUserExist: boolean = false;
  existingUser: any;

  constructor(
    public dialog: MatDialog,
    private readonly router: Router,
    private readonly formBuilder: FormBuilder,
    public readonly reportService: ReportService,
    public readonly userService: UserService,
    public readonly dialogService: DialogService,
    public readonly toast: ConfirmationToastComponent,
  ) {
    this.roles = this.userService.getRoleList();
    this.filtered_roles = this.roles?.filter((r: any) => r.type == "FOLO");
  }

  ngOnInit(): void {
    this.status.emit(undefined);
    this.loadUsers();
    console.log(this.report())
    this.forests = this.report().forests.map((forest: ReportForest) => {
      let newForest = forest as any;
      newForest.form = this.formBuilder.group({
        name_search: [""],
        new_or_existing: [forest.line_officer ? "existing" : ""],
        user_select: [""],
        first_name: [""],
        last_name: [""],
        email: [""],
        phone_num: [""],
        lo_position: [""]
      })
      newForest.selectUserForm = this.formBuilder.group({
        user: [forest.line_officer ?? ""],
      })
      newForest.userExists = false;
      newForest.contact = null;
      newForest.users = new MatTableDataSource<any>();
      return newForest;
    })
    this.loaded.emit(true);
  }

  ngOnChanges(): void {
    if (this.nav() != '') this.navigate();
  }

  navigate() {
    this.save()
    switch (this.nav()) {
      case 'forward': {
        if (this.report().report_status_id == 1) {
          this.reportService.updateReport({
            report_id: this.report().report_id,
            report_status_id: 2, //SUBMITTED
            authorization_status_id: 0, // FOLO SIGNATURE REQUESTED
            submission_date: new Date().toLocaleDateString("en-US", { year: "numeric", month: "2-digit", day: "2-digit" }),
          }).subscribe((x: any) => {
            this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() + 1 } });
          });
          break;
        }
        if (this.is_co()) {
          this.reportService.updateReport({
            report_id: this.report().report_id,
            report_status_id: 1 //READY FOR SUBMISSION
          }).subscribe((x: any) => {
            this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() + 1 } });
          });
        } else {
          this.reportService.updateReport({
            report_id: this.report().report_id,
            report_status_id: 3 //in review
          }).subscribe((x: any) => {
            this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() + 1 } });
          });
        }
        break;
      }
      case 'back': {
        this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: +this.page() - 1 } });
        break;
      }
      case 'close': {
        this.router.navigate(['fire-overview'], { queryParams: { assessment_id: this.report().assessment_id } });
        break;
      }
      default: {
        if (Number(this.nav()))
          this.router.navigate(['/2500-8-report'], { queryParams: { report_id: this.report().report_id, report_page_input: this.nav() } });
        break;
      }
    }
  }

  save() {
    let forests = this.forests.map((forest: any) => {
      return {
        forest_id: forest.forest_id,
        line_officer_id: forest.selectUserForm.value.user?.user_id
      }
    })
    this.update()

    this.reportService.updateReport({
      report_id: this.report().report_id,
      forests: forests,
      [`page_${this.page()}_status_id`]: this.report()[`page_${this.page()}_status_id`],
    }).subscribe({
      next: (response) => {
      },
      error: (response) => {
        this.toast.openErrorSnackBar(`There was an error saving the report`, "Please try again.");
      },
    })
  }

  loadUsers() {
    this.userService.getUserList("LO", ["baer_roles.baer_role"]).subscribe(data => {
      let users = data.users
      this.forests.forEach((forest: any) => {
        this.setUserPerForest(forest, users)
      })
      this.update()
      this.users.data = users
      this.dialogService.closeSpinner()
    });
  }

  setUserPerForest(forest: any, users: any) {
    users.forEach((user: any) => {
      user[forest.forest_name] = {}
      user[forest.forest_name].baer_roles = user.baer_roles.filter((role: any) => {
        return (role.baer_role.type.slice(-2) == "LO" && (role.forest_name ?? user.forest_name) == forest.forest_name)
      })
      user[forest.forest_name].tooltip = user.baer_roles.map((role: any) => role.baer_role.text).join("\n")
    })
    let LOs = users.filter((user: any) => user[forest.forest_name].baer_roles.length > 0)
    forest.users.data = LOs

    if (this.selectUserId) {
      let user = LOs.find((user: any) => user.user_id == this.selectUserId)
      if (user) {
        forest.selectUserForm.patchValue({
          user: user,
        })
        forest.form.patchValue({
          new_or_existing: 'existing',
        })
      }
      this.update()
    }
    if (forest.selectUserForm.value.user) {
      forest.selectUserForm.patchValue({
        user: LOs.find((user: any) => user.user_id == forest.selectUserForm.value.user.user_id)
      })
      this.update()
    }
  }

  radioChange(event: any, forest: any) {
    this.update(forest)
  }

  checkIfUserExists(forest: any): void {
    if (forest.form.controls.email.errors?.pattern) {
      forest.form.controls.email.setErrors({ "pattern": forest.form.controls.email.errors.pattern })
      return
    }
    let email = forest.form.value.email
    if (this.lastCheckedEmail == email) return // Prevent double event firing
    this.lastCheckedEmail = email
    if (email == "") {
      forest.form.controls.email.setErrors(null)
      return
    }
    let foundUser = forest.users.data.find((user: any) => user.email == email)
    if (foundUser) {
      forest.selectUserForm.patchValue({
        user: foundUser,
      })
      forest.form.patchValue({
        new_or_existing: 'existing',
      })
      this.update(forest);
      this.toast.openSuccessSnackBar(`Existing Line Officer Found`, "The line officer with that email address has been selected.");
      return
    }
    this.dialogService.openSpinner();
    this.userService.getUsersByEmail(email).subscribe({
      next: (response) => {
        this.dialogService.closeSpinner();
        if (response.totalResults > 0) {
          this.doesUserExist = true;
          this.existingUser = response.users?.[0];
          forest.form.controls.first_name.patchValue(this.existingUser.first_name);
          forest.form.controls.last_name.patchValue(this.existingUser.last_name);
          forest.form.controls.phone_num.patchValue(this.existingUser.phone_num);
        } else {
          this.doesUserExist = false;
          this.existingUser = undefined;
        }
      },
      error: (response) => {
        forest.userExists = false;
        this.dialogService.closeSpinner();
      },
      complete: () => {
        this.update()
      }
    })
  }

  update(doneForest?: any) {
    let touched = false
    let complete = true

    this.forests.forEach((forest: any) => {
      if (doneForest?.forest_id == forest.forest_id) {
        touched = true
        return
      }
      if (forest.selectUserForm.value.user) {
        touched = true
      } else {
        complete = false
      }
    })

    if (touched) {
      this.report()[`page_${this.page()}_status_id`] = 1
    }
    if (complete) {
      this.report()[`page_${this.page()}_status_id`] = 2
      this.status.emit(2);
    } else this.status.emit(1);
  }

  upsertLineOfficer(forest: any) {
    let phone_num = forest.form.value.phone_num
    if (forest.form.value.phone_num == "") {
      phone_num = undefined
    }
    this.dialogService.openSpinner()
    if (!this.doesUserExist) {
      this.userService.createNewUser({
        first_name: forest.form.value.first_name!,
        last_name: forest.form.value.last_name!,
        region: forest.region,
        forest_name: forest.forest_name,
        location_id: 0,
        agency_id: 0,
        phone_num: phone_num,
        email: forest.form.getRawValue().email!,
        user_baer_roles: [
          { baer_role_id: 2, forest_name: forest.forest_name, location_id: 0, region: forest.region },
          { baer_role_id: forest.form.value.lo_position.value, forest_name: forest.forest_name, location_id: 0, region: forest.region }
        ],
        procedure: "NEW_TO_LINE_OFFICERS"
      }).subscribe((response: any) => {
        if (response.user_id) {
          this.selectUserId = response.user_id
          this.loadUsers()
        }
      });
    } else {
      this.userService.editUserDetails({
        user_id: this.existingUser.user_id,
        first_name: forest.form.value.first_name!,
        last_name: forest.form.value.last_name!,
        region: forest.region,
        forest_name: forest.forest_name,
        agency_id: 0,
        phone_num: phone_num,
        user_baer_roles: [
          { baer_role_id: forest.form.value.lo_position.value, forest_name: forest.forest_name, location_id: 0, region: forest.region }
        ],
        procedure: "REASSIGN"
      }).subscribe(() => {
        this.selectUserId = this.existingUser.user_id
        this.loadUsers()
      });
    }

  }
}
